:host {
  --aha-progress-step--background-color: var(
    --aha-progres-steps--background-color,
    var(--theme-button-primary)
  );

  --aha-progress-step--color: var(--aha-progress-steps--color, var(--theme-inverted-primary-text));

  --aha-progress-step--connector-color: var(
    --aha-progress-steps--connector-color,
    var(--aha-progress-step--background-color)
  );

  display: flex;
  flex-direction: column;
}
[hidden] {
  display: none !important;
}
#content {
  display: flex;
  flex-direction: row;
  gap: var(--spacer-2);
  align-items: center;
}
#line-container,
#number {
  width: var(--aha-progress-steps--number-width);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
#number {
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border-color: var(--aha-progress-step--background-color);
  background: var(--aha-progress-step--background-color);
  color: var(--aha-progress-step--color);
  position: relative;
  z-index: 10;
}
:host([current]) #number::before {
  content: var(--aha-progress-steps--pulse);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: inherit;
  border-width: 0.25em;
  border-style: var(--aha-progress-steps--pulse-style);
  border-color: inherit;
  animation-name: ring;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  transform-origin: center;
  z-index: -1;
}
#digits {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform-origin: center;

  /* Scaling a default font size of 12px to display as 10px. This way the font size of the number in the circle is relative to the font size of the text of the `<aha-progress-steps>`. Cannot use font-size directly, as we don't necessarilyy have a specified font-size, may just inherit. */
  transform: scale(calc(10 / 12));
}
#line {
  position: relative;
  height: var(--aha-progress-steps--line-length, 2em);
  width: var(--aha-progress-steps--line-width);
  background-color: var(--aha-progress-step--connector-color);
}

/* Draw the "mustache" the connects the line at the top and bottom. */
#line::before,
#line::after {
  content: '';
  display: block;
  background: radial-gradient(
    circle at var(--aha-progress-step--cutout-placement) center,
    transparent,
    transparent var(--aha-progress-steps--cutout-size),
    var(--aha-progress-step--connector-color) var(--aha-progress-steps--cutout-size),
    var(--aha-progress-step--connector-color)
  );
  position: absolute;
  left: 0;
  right: 0;
  width: var(--aha-progress-steps--line-width);
  height: var(--aha-progress-steps--cutout-size);
  z-index: 100;
}
#line::before {
  --aha-progress-step--cutout-placement: top;
  top: calc(-1 * var(--aha-progress-steps--cutout-size));
}
#line::after {
  --aha-progress-step--cutout-placement: bottom;
  bottom: calc(-1 * var(--aha-progress-steps--cutout-size));
}

@keyframes ring {
  0% {
    transform: rotate(180deg) scale(0.75);
    opacity: 1;
  }
  30%,
  100% {
    transform: rotate(180deg) scale(1.85);
    opacity: 0;
  }
}
